import { useMutation } from '@tanstack/react-query';

import { postRequest } from '~services';
import { ASSET_CATEGORY, ASSET_TYPE } from '~types';

export interface IUploadPhotoReqParams {
  file: File;
  type: ASSET_TYPE;
  category: ASSET_CATEGORY;
}

export const useUploadFileMutation = () => {
  return useMutation({
    mutationFn: (reqBody: IUploadPhotoReqParams) => {
      const request = new FormData();

      for (const [key, value] of Object.entries(reqBody)) {
        if (value instanceof File) request.append(key, value);
        else if (value) {
          request.append(key, value + '');
        }
      }

      return postRequest({
        path: 'api/file/upload',
        data: request,
        allowIsMobilePinningParams: false,
      });
    },
  });
};
